//natives
import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import ListItemIcon from "@material-ui/core/ListItemIcon";

export default (value, tableMeta) => {
    return (
        <div>
            <Tooltip title={"Configurar Opção recebimento"}>
                <a href={`/#/confOpcoesRecebimento/${tableMeta.rowData[0]}`}>
                    <ListItemIcon>
                        <i className="material-icons">request_quote</i>
                    </ListItemIcon>
                </a>
            </Tooltip>

            <Tooltip title={"Adicionar Fornecedor"}>
                <a href={`/#/fornecedoresGrupo/${tableMeta.rowData[0]}`}>
                    <ListItemIcon>
                        <i className="material-icons">manage_accounts</i>
                    </ListItemIcon>
                </a>
            </Tooltip>

            <Tooltip title={"Editar item"}>
                <a href={`#/grupoOpcoesRecebimento-ae/${tableMeta.rowData[0]}`}>
                    <ListItemIcon>
                        <i className="material-icons">edit</i>
                    </ListItemIcon>
                </a>
            </Tooltip>
        </div>
    );
};
